import React from "react";
import PropTypes from "prop-types";

export default function PromotionsBar() {
    const isPromotion = true;

    return (
        <>
            {((isPromotion) &&
                <div className="promotion-bar">
                    Jetzt 4 BIO Programme zur Berechnung des geldwerten Bio-Anteils am Wareneinsatz
                    <a href="/products/gk01-1">gk01.1</a>
                    <a href="/products/gk06-1">gk06.1</a>
                    <a href="/products/gk16-1">gk16.1</a>
                    <a href="/products/gk17-1">gk17.1</a>
                </div>
            )
            }
        </>
    );
}

PromotionsBar.propTypes = {
    promotionMsg: PropTypes.string,
};
